module.exports = __webpack_public_path__ + "img/125.8.af086dcd.png";